var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eus1z5h81a",
    x1: 1,
    y1: 1,
    x2: 0,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff2264"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb100"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18440",
    transform: "translate(-1179.5 -6957)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 96",
    width: 36,
    height: 36,
    rx: 7,
    transform: "translate(1179.5 6957)",
    style: {
      fill: "url(#eus1z5h81a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10502",
    d: "M38.343 35.472A2.472 2.472 0 1 1 35.872 33a2.472 2.472 0 0 1 2.471 2.472z",
    transform: "translate(1156.18 6932.013)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10503",
    d: "M40.589 69.893v10.92a.611.611 0 0 1-.611.615h-2.605a.611.611 0 0 1-.613-.613V69.893a.613.613 0 0 1 .613-.613h2.605a.613.613 0 0 1 .611.613z",
    transform: "translate(1153.374 6901.711)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10504",
    d: "M82.362 74.659v5.286a.562.562 0 0 1-.564.564H79a.562.562 0 0 1-.564-.564v-5.123c0-.765.224-3.348-2-3.348-1.722 0-2.073 1.768-2.142 2.562v5.909a.564.564 0 0 1-.555.564h-2.707a.562.562 0 0 1-.562-.564V68.926a.562.562 0 0 1 .562-.564h2.706a.564.564 0 0 1 .564.564v.952a3.835 3.835 0 0 1 3.609-1.7c4.479 0 4.452 4.182 4.452 6.479z",
    transform: "translate(1125.218 6902.63)",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.aa77ae528198d3e1e210e181ffaf3575.svg";
export { ForwardRef as ReactComponent };